<div class="col-sm-12">
    <div class="row">
      <app-filtre-recherche-collaborateur (collaborateurSeach)="collaborateurChange($event)" (updateFiltre)="updateFiltre($event)"></app-filtre-recherche-collaborateur> 
    </div>
    <app-list-collaborateur [comingFrom]="data.comingFrom" [reponseCollaborateur] = "reponseCollaborateur" [filtre]="filtre" (selectCollab)="dialogRef.close()"></app-list-collaborateur>
    
</div>